/*
 * Component that displays all programs
**/

import React from 'react'
import {useStaticQuery, graphql, Link} from 'gatsby'

import {
  Grid,
  Image,
  Message,
} from 'semantic-ui-react'

const Faqs = () => {
  const data = useStaticQuery(graphql`
    {
      allWordpressWpFaqs {
        edges {
          node {
            acf {
              order
            }
            slug
            template
            title
            excerpt
            content
            status
            id
          }
        }
      }

    }
`)

    let columns = data
      .allWordpressWpFaqs
      .edges
      .sort( (a,b)=>a.node.acf.order > b.node.acf.order )
      .map( edge=>{
        let {node} = edge
        let {
          excerpt,
          slug,
          title,
          featured_media,
        } = node
        let url = `/faqs/${slug}`
        let image

        if (featured_media) {
          let { source_url, base} = featured_media
          image = <Image src={source_url} alt={base} />
        }

        return <Grid.Column>
          {/* Use message to override the link color */}
          <Message>
              <Link to={url} style={ {color: "black"} }>
                <h1>
                    {title}
                </h1>
                {image}
                <div dangerouslySetInnerHTML={ {__html: excerpt}} />
              <br/>
              </Link>
          </Message>
        </Grid.Column>
    })

    return (
      <Grid stackable columns={3}>
        {columns}
      </Grid>)
}

export default Faqs
